import { render, staticRenderFns } from "./CPSProduct.vue?vue&type=template&id=66700e5c&scoped=true"
import script from "./CPSProduct.vue?vue&type=script&lang=js"
export * from "./CPSProduct.vue?vue&type=script&lang=js"
import style0 from "./CPSProduct.vue?vue&type=style&index=0&id=66700e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66700e5c",
  null
  
)

export default component.exports